import { Box, Typography } from "@mui/material";
import { DocumentsList } from "Components/LegalDocuments/DocumentsList";
import { useSocialTermsDocuments } from "Components/Social/SocialTermsConsent/useSocialTermsDocuments";
import { Fragment } from "react";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Social.Terms.Summary;
const DOCUMENTS_LABEL = Resources.Social.Terms.Documents.ListLabel;

const SUMMARY_ROW_KEYS = [
  "Service",
  "Provider",
  "Price",
  "Duration",
  "Termination",
  "Withdrawal",
  "Payments",
  "Complaints",
  "Devices",
  "Important",
] as const satisfies ReadonlyArray<keyof typeof RESOURCES>;

/**
 * Contract summary of the chat service (label/value rows, consumer-law style) followed by the
 * documents to download — the content of the "Shrnutí a dokumenty" block. Deliberately not a
 * scroll box of its own: the host (dialog content, bottom sheet, onboarding page) is the single
 * scroll region, a nested scrollbar here read as a confusing "double scroll".
 */
export const SocialTermsSummary = () => {
  const { t } = useResource();
  const { all: documents } = useSocialTermsDocuments();

  return (
    <Box
      p={2}
      sx={({ palette, shape }) => ({
        border: `1px solid ${palette.divider}`,
        borderRadius: `${shape.borderRadius}px`,
      })}
    >
      <Box
        display="grid"
        gridTemplateColumns="minmax(88px, 1fr) 2fr"
        columnGap={2}
        rowGap={1.5}
      >
        {SUMMARY_ROW_KEYS.map((key) => (
          <Fragment key={key}>
            <Typography variant="body2" color="text.secondary">
              {t(RESOURCES[key].Label)}
            </Typography>
            <Typography variant="body2">{t(RESOURCES[key].Value)}</Typography>
          </Fragment>
        ))}
      </Box>
      <Typography variant="body2" color="text.secondary" mt={1.5}>
        {t(DOCUMENTS_LABEL)}
      </Typography>
      <DocumentsList documents={documents} />
    </Box>
  );
};
